<template>
    <v-container>
        <h2 class="text-center">{{ awards.title }}</h2>
        <v-row class="flex-wrap fill-height" align="center" justify="center">
            <v-col cols="10" md="4"
            v-for="(item, i) in awards.list" 
            :key="i">
                <v-card class="mx-auto card-bounce">
                  <v-img contain @click.stop="dialog = true, dialogData = item"
                    :style="{ cursor: 'pointer' }"
                    class="card-style" 
                    :lazy-src="require('@/assets/animate-logo-white.svg')"
                    :src="encodeURI(`/img/rewards/descriptions/${item}-description.jpg`)" />
                </v-card>
            </v-col>
        </v-row>

        <!-- Модальное окно -->
        <v-dialog 
        v-model="dialog"
        max-width="115vh">
            <v-img contain
            :lazy-src="require('@/assets/animate-logo-white.svg')"
            :src="encodeURI(`/img/rewards/descriptions/${dialogData}-description.jpg`)" />
        </v-dialog>
        <!--  -->
    </v-container>
</template>

<script>
  export default {
    name: 'DescriptionCard',
    props: {
      awards: Object
    },
     data: () => ({
        dialog: false, // переключатель окна диалога
        dialogData: String // данные для отображения в окне диалога
    })
  }
</script>
